<template>
	<div v-if="!inline" class="checkbox" :class="[setDis]">
		<label>
		    <input type="checkbox"  :name="name" :value="val"  :disabled="disabled">
		    {{label}}
 		 </label>
	</div>
	<label v-else class="checkbox-inline">
	    <input type="checkbox"  :name="name" :value="val"  :disabled="disabled">
	    {{label}}
 	</label>
</template>

<script>
	export default {
		name: 'bsf-checkbox',
		components: {},
		props: {
			label: {
				type: String
			},
			disabled: {
				type: Boolean,
				default: false
			},
			name: {
				type: String
			},
			val: {
				type: String
			},
			inline:{
				type:Boolean,
				default: false
			}
		},
		data: function() {
			return {}
		},
		mounted: function() {
			this.$nextTick(function() {

			})
		},
		computed: {
			setDis() {
				return this.disabled ? "disabled" : "";
			},
			isInline() {
				return this.direction ? "form-" + this.direction : "";
			}
		}

	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import (reference) "../../../assets/lib/css.less";
	.checkbox,
	.radio {
		&.disabled {
			color: @cc2;
		}
	}
</style>


// WEBPACK FOOTER //
// checkbox.vue?b54d8870